import React, { useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Toast from './Toast';
import { renderProductImage } from '../utils/imageHelpers';

const ProductCard = ({ product, onAddToCart, onClick }) => {
  const { t } = useTranslation();
  const [quantity, setQuantity] = useState(1);
  const [showToast, setShowToast] = useState(false);
  
  const decreaseQuantity = (e) => {
    e.stopPropagation();
    if (quantity > 1) {
      setQuantity(quantity - 1);
    }
  };
  
  const increaseQuantity = (e) => {
    e.stopPropagation();
    setQuantity(quantity + 1);
  };
  
  const handleAddToCart = (e) => {
    e.stopPropagation();
    onAddToCart({...product, quantity});
    setShowToast(true);
  };
  
  return (
    <>
      <Toast 
        show={showToast} 
        onClose={() => setShowToast(false)} 
        message="L'articolo è stato aggiunto al carrello"
      />
      <Card className="h-100 shadow-sm border-0 rounded-4 cursor-pointer" onClick={onClick} style={{ transition: 'box-shadow 0.2s' }}>
        <div className="position-relative" style={{ width: '100%', aspectRatio: '1/1', overflow: 'hidden' }}>
          {product.image ? (
            <img
              src={product.image}
              alt={product.name}
              style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }}
            />
          ) : (
            renderProductImage(product.image, product.name, 'thumbnail')
          )}
        </div>
        <Card.Body className="d-flex flex-column">
          <Card.Title className="fs-6 mb-1">{product.name}</Card.Title>
          <Card.Text className="fw-bold text-primary mb-2">€{product.price.toFixed(2)}</Card.Text>
          
          <div className="mt-auto">
            <div className="d-flex align-items-center justify-content-between">
              <div 
                className="d-flex align-items-center bg-light rounded-pill px-1 py-1" 
                style={{ border: '1px solid #eee', backgroundColor: '#f8f9fa' }}
              >
                <button 
                  className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                  style={{ 
                    width: '30px', 
                    height: '30px', 
                    padding: 0,
                    backgroundColor: 'white',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    border: 'none'
                  }}
                  onClick={decreaseQuantity}
                >
                  <i className="bi bi-dash text-muted"></i>
                </button>
                
                <span className="fw-bold mx-3" style={{ fontSize: '18px' }}>{quantity}</span>
                
                <button 
                  className="btn btn-sm rounded-circle d-flex align-items-center justify-content-center"
                  style={{ 
                    width: '30px', 
                    height: '30px', 
                    padding: 0,
                    backgroundColor: 'white',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                    border: 'none'
                  }}
                  onClick={increaseQuantity}
                >
                  <i className="bi bi-plus text-muted"></i>
                </button>
              </div>
              
              <Button 
                variant="primary" 
                size="sm" 
                className="rounded-circle p-0"
                style={{ width: '38px', height: '38px', backgroundColor: "#0A0A17", borderColor: "#0A0A17" }}
                onClick={handleAddToCart}
              >
                <i className="bi bi-basket2 fs-5"></i>
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    </>
  );
};

export default ProductCard; 